import { WindowCloseDirective } from './window-close.directive';

export class WindowUtil {

  public static windowUrlOpen(btnUrl: string, width: number = 1200, height: number = 900): any {
    const target_url = btnUrl;
    let topValue = (window.screen.availHeight - 30 - height) / 2;
    let leftValue = (window.screen.availWidth - 10 - width) / 2;
    if (!!target_url) {
      if (target_url.indexOf('fullsize=true') > 0) {
        width = window.screen.availWidth;
        height = window.screen.availHeight;
        topValue = 0;
        leftValue = 0;
      }
      const win = window.open(target_url, '',
        'width=' + width + ', height=' + height + ', top=' + topValue + ', left=' + leftValue +
        ',toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no');
      const winList = WindowCloseDirective.winList;
      winList.push(win);

      if (WindowCloseDirective.winList !== null && WindowCloseDirective.winList.length > 0) {
        const winItem = WindowCloseDirective.winList[0];
        if (winItem.closed) {
          WindowCloseDirective.winList = new Array<any>();
        }
      }
      if (WindowCloseDirective.winList.length > 1) {
        win.close();
        return null;
      }

      WindowCloseDirective.winList = winList;
      return win;
    } else {
      return null;
    }
  }

  public static windowClose() {
    window.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/utility/window-util.ts